import { jsx as _jsx } from "react/jsx-runtime";
import { routes } from '#pplx/frontend/apps/ask/routing/spaRoutes.js';
import { LinkOutIcon, LinkInternalIcon, } from '#pplx/frontend/apps/ask/settings/config/TabConfigsComponents.js';
import { SETTINGS_PREFIX } from '#pplx/frontend/apps/ask/settings/constants.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
// Re-export for backward compatibility
export const settingsPrefix = SETTINGS_PREFIX;
export const BaseSettingsSidebarTabs = {
    Account: {
        show: true,
        icon: $icon('user-circle'),
        href: routes['/account/details'].href(),
    },
    Preferences: {
        show: true,
        icon: $icon('adjustments'),
        href: routes['/account/preferences'].href(),
    },
    Personalize: {
        show: true,
        icon: $icon('toggle-right'),
        href: routes['/account/personalize'].href(),
    },
    AccountMemorySettings: {
        show: true,
        icon: $icon('brain'),
        href: routes['/account/memory'].href(),
    },
    Connectors: {
        show: true,
        icon: $icon('plug'),
        href: routes['/computer/connectors'].href(),
        trailingComponent: _jsx(LinkInternalIcon, {}),
    },
    Skills: {
        show: true,
        icon: $icon('blocks'),
        href: routes['/computer/skills'].href(),
        trailingComponent: _jsx(LinkInternalIcon, {}),
    },
    Plugins: {
        show: true,
        icon: $icon('puzzle'),
        href: routes['/computer/plugins'].href(),
        trailingComponent: _jsx(LinkInternalIcon, {}),
    },
    Memory: {
        show: true,
        icon: $icon('brain'),
        href: routes['/computer/memory'].href(),
        trailingComponent: _jsx(LinkInternalIcon, {}),
    },
    CredentialsVault: {
        show: true,
        icon: $icon('lock'),
        href: routes['/account/credentials-vault'].href(),
    },
    API: {
        show: true,
        icon: $icon('cloud-data-connection'),
        href: routes['/account/api'].href(),
    },
    Enterprise: {
        show: true,
        icon: $icon('building'),
        trailingComponent: _jsx(LinkInternalIcon, {}),
    },
    EnterpriseUpgrade: {
        show: true,
        icon: $icon('rocket'),
    },
    APILearnMore: {
        show: true,
        icon: $icon('book'),
        trailingComponent: _jsx(LinkOutIcon, {}),
    },
    Notifications: {
        show: true,
        icon: $icon('bell'),
        href: routes['/account/notifications'].href(),
    },
    Analytics: {
        show: true,
        icon: $icon('chart-infographic'),
        href: routes['/account/analytics'].href(),
    },
    Computer: {
        show: true,
        icon: $icon('settings'),
        href: routes['/account/computer'].href(),
    },
    Devices: {
        show: true,
        icon: $icon('device-laptop'),
        href: routes['/account/devices'].href(),
    },
    Tasks: {
        show: true,
        icon: $icon('calendar-time'),
        href: routes['/account/tasks'].href(),
    },
    Shortcuts: {
        show: true,
        icon: $icon('square-forbid-2'),
        href: routes['/account/shortcuts'].href(),
    },
    SiteInstructions: {
        show: true,
        icon: $icon('settings-2'),
        href: routes['/account/site-instructions'].href(),
    },
    Credits: {
        show: true,
        icon: $icon('battery-3'),
        href: routes['/account/usage'].href(),
    },
};
export const EnterpriseSettingsSidebarTabs = {
    Organization: {
        show: true,
        icon: $icon('building'),
        href: routes['/account/org/details'].href(),
    },
    Members: {
        show: true,
        icon: $icon('users'),
        href: routes['/account/org/members'].href(),
    },
    Identity: {
        show: true,
        icon: $icon('id-badge-2'),
        href: routes['/account/org/identity'].href(),
    },
    OrgDataPrivacy: {
        show: true,
        icon: $icon('shield-lock'),
        href: routes['/account/org/data-privacy'].href(),
    },
    OrgEncryption: {
        show: true,
        icon: $icon('lock'),
        href: routes['/account/org/encryption'].href(),
    },
    Apps: {
        show: true,
        icon: $icon('apps'),
        href: routes['/account/org/apps'].href(),
    },
    Connectors: {
        show: true,
        icon: $icon('plug'),
        href: routes['/account/org/connectors'].href(),
    },
    Skills: {
        show: true,
        icon: $icon('blocks'),
        href: routes['/account/org/skills'].href(),
    },
    Plugins: {
        show: true,
        icon: $icon('puzzle'),
        href: routes['/account/org/plugins'].href(),
    },
    OrgCredentialsVault: {
        show: true,
        icon: $icon('key'),
        href: routes['/account/org/credentials-vault'].href(),
        trailingComponent: _jsx(LinkOutIcon, {}),
    },
    Analytics: {
        show: true,
        icon: $icon('chart-infographic'),
        href: routes['/account/org/analytics'].href(),
    },
    OrgComputerSetup: {
        show: true,
        icon: $icon('custom-computer'),
        href: routes['/account/org/computer'].href(),
    },
    OrgEnterpriseApis: {
        show: true,
        icon: $icon('key'),
        href: routes['/account/org/enterprise-apis'].href(),
    },
    OrgCometSetup: {
        show: true,
        icon: $icon('custom-brand-comet'),
        href: routes['/account/org/comet'].href(),
    },
    OrgCometTelemetry: {
        show: true,
        icon: $icon('activity'),
        href: routes['/account/org/comet-telemetry'].href(),
    },
    OrgCreditsUsage: {
        show: true,
        icon: $icon('battery-3'),
        href: routes['/account/org/credits-usage'].href(),
    },
    OrgBilling: {
        show: true,
        icon: $icon('credit-card'),
        href: routes['/account/org/billing'].href(),
    },
    OrgRolesPermissions: {
        show: true,
        icon: $icon('user-shield'),
        href: routes['/account/org/roles-permissions'].href(),
    },
};
//# sourceMappingURL=TabConfigs.js.map